import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import SelectInput from 'components/Form/components/SelectInput'
import styles from '../../BankTransferDisplayForm.scss'

class InternalDttForm extends Component {
    static propTypes = {
      bankTransferAccountsOptions: PropTypes.object.isRequired,
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleSelectChange: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        bankTransferAccountsOptions, schema, form, handleChange, handleSelectChange, handleValidation, handleFocus,
      } = this.props   
      return (
        <div className={styles.fieldset}>
          <li>
            <SelectInput
              {...schema.account}
              searchable
              error={form.account.error}
              handleChange={handleSelectChange}
              onBlur={handleValidation}
              options={bankTransferAccountsOptions} // load from BED?
              valid={form.account.valid}
              value={form.account.value}
            />
          </li>
          <li>
            <TextInput
              {...schema.amount}
              error={form.amount.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.amount.value}
              valid={form.amount.valid}
            />
          </li></div>
      )
    }
}

export default InternalDttForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/InternalDttForm.js